export const TEST_AUDIENCE = 'test-audience'
export const CM_PRICE_TEST = 'q423_pricing_test_cm'
export const EB_PRICE_TEST = 'q423_pricing_test_eb'
export const CW_PRICE_TEST = 'cw-price-test'
export const SEM_EB_PRICE_TEST = 'sem-eb-price-test'
export const SEM_CW_PRICE_TEST = 'sem-cw-price-test'
export const UPLOAD_WIDGET_DEMO = 'upload-widget-demo'
export const UPDATE_AUTH_MODAL_EB = 'eb-update-auth-modal'
export const DISABLE_PARTIAL_PLAG_CHECK = 'disable-partial-plag-check'



// WEBPACK FOOTER //
// ./src/state/optimizely/constants.ts